import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var tooltipTrigger = createRuntimeFn({defaultClassName:'fx_e395032e_1e9jm180',variantClassNames:{transparent:{true:'fx_e395032e_1e9jm181',false:'fx_e395032e_1e9jm182'}},defaultVariants:{transparent:false},compoundVariants:[]});

export { tooltipTrigger };
//# sourceMappingURL=trigger.vanilla.mjs.map
